import { ReactElement, useCallback, memo } from 'react';
import { ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCubes as ByItemsIcon,
  faCopy as ByTemplateIcon,
} from '@fortawesome/free-solid-svg-icons';

import { PlanFeaturesTypes } from '~globals/types/enums';

import { AssistantGenerateRoutesActionMenuProps } from './types';
import AssistantGenerateRoutesActionMenuItem from './MenuItem';
import { AssistantGenerateRoutesActionMenuContainer } from './styles';

const AssistantGenerateRoutesActionMenu = ({
  anchorEl,
  anchorOrigin = {
    vertical: 'bottom',
    horizontal: 'center',
  },
  transformOrigin = {
    vertical: 'top',
    horizontal: 'center',
  },
  open,
  onClose,
  bytItems,
  byTemplate,
}: AssistantGenerateRoutesActionMenuProps): ReactElement => {
  const handleClickItem = useCallback(
    (callback: () => void) => {
      callback();
      onClose?.({}, 'backdropClick');
    },
    [onClose],
  );

  return (
    <AssistantGenerateRoutesActionMenuContainer
      id="s-assistant-generate-routes-actions-menu"
      anchorEl={anchorEl}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      open={open}
      onClose={onClose}
      elevation={0}
    >
      <AssistantGenerateRoutesActionMenuItem
        onClick={() => handleClickItem(bytItems.onOpenDialog)}
        disabled={bytItems.disabled}
      >
        <ListItem disableGutters disablePadding component="div">
          <ListItemIcon>
            <FontAwesomeIcon icon={ByItemsIcon} />
          </ListItemIcon>

          <ListItemText primary="Desde pedidos" />
        </ListItem>
      </AssistantGenerateRoutesActionMenuItem>

      <AssistantGenerateRoutesActionMenuItem
        validSubscriptionFeature={{
          validFeature: PlanFeaturesTypes.MgmRepeatRoutes,
        }}
        onClick={() => handleClickItem(byTemplate.onOpenDialog)}
        disabled={byTemplate.disabled}
      >
        <ListItem disableGutters disablePadding component="div">
          <ListItemIcon>
            <FontAwesomeIcon icon={ByTemplateIcon} />
          </ListItemIcon>

          <ListItemText primary="Desde plantilla" />
        </ListItem>
      </AssistantGenerateRoutesActionMenuItem>
    </AssistantGenerateRoutesActionMenuContainer>
  );
};

export default memo(AssistantGenerateRoutesActionMenu);
